import React from "react";
import { Alert, Input, Label } from "reactstrap";

const CHOICES = [
  ['transfer', 'Cancel it and transfer the remaining credits'],
  ['fresh', 'Cancel it and start fresh'],
];

// An active plan (is_premium: a trial or a grace included) is replaced only after the admin picks what happens
// to its credits; the backend refuses the assignment without it (Seasonal-Pass.md D2)
const ExistingPlanChoice = ({ organization, value, onChange }) => {
  if (!organization?.is_premium) return null;

  const plan = organization.plan_details || {};
  const remaining = Math.max(0, (plan.max_credits || 0) - (plan.credits || 0));

  return (
    <Alert color="warning" className="mb-3">
      <div className="mb-2">
        <strong>This organization has an active plan:</strong> {plan.name || 'Unknown'}
        {organization.is_on_trial ? ' (trial)' : ''}, {remaining} credits left. It ends now, with no refund.
      </div>
      {CHOICES.map(([key, label]) => (
        <div className="form-check" key={key}>
          <Input
            type="radio"
            id={`existing-plan-${key}`}
            name="existingPlanAction"
            checked={value === key}
            onChange={() => onChange(key)}
            className="form-check-input"
            style={{ cursor: 'pointer' }}
          />
          <Label className="form-check-label" htmlFor={`existing-plan-${key}`} style={{ cursor: 'pointer' }}>
            {key === 'transfer' ? `${label} (${remaining})` : label}
          </Label>
        </div>
      ))}
    </Alert>
  );
};

export default ExistingPlanChoice;
